<template>
    <div v-if="statements && statements.length">
        <div v-for="item in statements" :key="item.serialNumber + item.dateTime" class="history-item">
            <user-meters-table
                v-if="item"
                :fullAddress="item.fullAddress"
                :item="item"
                :serialNumber="item.serialNumber"
            />
        </div>
    </div>
    <div v-else-if="!noStatement">Загрузка...</div>
    <div v-else>Нет истории показаний</div>
</template>

<script>
export default {
    name: 'user-meters-data',
    data() {
        return {
            show: false
        }
    },
    mounted() {
        this.fetchStatements()
    },
    watch: {
        '$store.state.currentAccount.account_id'() {
            this.fetchStatements()
        }
    },
    computed: {
        statements() {
            return this.$store.getters.currentStatemet
        },
        noStatement() {
            return this.$store.state.noStatement
        }
    },
    methods: {
        fetchStatements() {
            this.$store.commit('getPremisesMetersStatements')
        }
    },
}
</script>